<template>
  <div>
    <BackButton class="u-margin-bottom-small"></BackButton>
    <SuggestionForm @submit="updateSuggestion($event)" :loadingSave="loadingSave" />
  </div>
</template>

<script>
import BackButton from '@/components/buttons/BackButton';
import SuggestionForm from '@/pages/Suggestions/SuggestionForm';
import DashboardElementController from '@/controllers/DashboardElement/DashboardElementController';
import QuestionController from '@/controllers/Question/QuestionController';
export default {
  name: 'EditSuggestion',
  components: { SuggestionForm, BackButton },
  data() {
    return {
      loadingSave: false,
    };
  },
  methods: {
    async updateSuggestion(form) {
      this.loadingSave = true;
      try {
        let dashElement = await DashboardElementController.update(form, form.dashboard_element_id);
        form.dashboard_element_id = dashElement.id;
        if (!form.question_text) form.question_text = form.headline;
        await QuestionController.update(form, form.id);
        await this.$router.push({ name: 'Suggestions' });
        this.$gtag.event('Suggestion Updated', { method: 'Google' });
        this.$notify({
          type: 'success',
          title: 'Successfully updated!',
        });
      } catch (error) {
        this.$gtag.exception({
          description: 'Error By Updating Suggestion',
          fatal: false,
        });
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
      this.loadingSave = false;
    },
  },
};
</script>

<style scoped></style>
